import React, { useState } from "react";
import DonationQuote from "../components/DonationQuote";
import BankDetails from "../components/BankDetails";
import DonationForm from "../components/DonationForm";

const DonationPage = () => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <section className="bg-[#f5f9f8] py-20 px-4 sm:px-6 lg:px-12 min-h-[80vh]">
      <div className="max-w-5xl mx-auto space-y-16">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-green-800 mb-4">
            Donate to Shree Nirmala Sahaja Yoga Charitable Trust
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto">
            Your donation helps us spread peace, meditation, and self-realization freely to all.
          </p>
        </div>

        <BankDetails />

        {!submitted ? (
          <div className="max-w-2xl mx-auto space-y-6">
            <h3 className="text-xl font-semibold text-green-700 text-center">
              Fill this form to receive the UPI QR Code for donating
            </h3>
            <DonationForm onSuccess={() => setSubmitted(true)} />
          </div>
        ) : (
          <div className="text-center space-y-6">
            <h3 className="text-2xl font-semibold text-green-700">
              ✅ Thank you! Please scan the QR to complete your donation
            </h3>
            <img
              src="/Donation.png"
              alt="UPI QR Code"
              className="mx-auto w-72 rounded-lg border shadow"
            />
            <p className="text-gray-700">
              Need help? Email us at:
              <br />
              <a href="mailto:nirmalsahaja.amd@gmail.com" className="text-green-800 underline font-medium">
                nirmalsahaja.amd@gmail.com
              </a>
            </p>
          </div>
        )}

        <DonationQuote />
      </div>
    </section>
  );
};

export default DonationPage;
